// Woocommerce appointments custom scripts

/**
 * This handles setting the max values for each of our inputs correctly, based on the global maximum.
 */
const setMaxValueForAddons = () => {
  let maxValue = parseInt(jQuery(".our-quantity-holder").attr("data-max"));
  if (isNaN(maxValue)) return;
  let qtyValue = parseInt(jQuery(".our-quantity-holder input").val());
  if (isNaN(qtyValue)) qtyValue = 0;
  let studValue = parseInt(jQuery(".pao-student").val());
  if (isNaN(studValue)) studValue = 0;
  let childValue = parseInt(jQuery(".pao-child").val());
  if (isNaN(childValue)) childValue = 0;
  // First, we check the quantity maximum, either the current value or the max of all the other values.
  let qtyMax = Math.max(maxValue - (studValue + childValue), qtyValue);
  jQuery(".our-quantity-holder input").attr("max", qtyMax);
  // Then we do the same for the other values.
  let studMax = Math.max(maxValue - (qtyValue + childValue), studValue);
  jQuery(".pao-student").attr("max", studMax);
  let childMax = Math.max(maxValue - (qtyValue + studValue), childValue);
  jQuery(".pao-child").attr("max", childMax);
};

/**
 * Controls the visibility of a notification element based on the quantity input value compared to the maximum.
 * If the quantity is less than the maximum, the notification is hidden.
 */
const handleShowingNotification = () => {
  if (
    isNaN(parseInt(jQuery(".qty").val())) ||
    isNaN(parseInt(jQuery(".our-quantity-holder").attr("data-max")))
  )
    return;
  const qty = parseInt(jQuery(".qty").val());
  const max = parseInt(jQuery(".our-quantity-holder").attr("data-max"));
  const notification = jQuery(".wc-notice-max-qty");
  if (qty < max) {
    notification.hide(400);
    return;
  }
  // Do not show for now.
  // notification.show(400);
};

/**
 * Handles checking if the quantity is low to hide the booking calendar.
 *
 * @param {number} qty
 */
const checkForHidingCalendar = (qty) => {
  const appointmentForm = document.querySelector(
    "#wc-appointments-appointment-form"
  );
  const appointmentFormButton = document.querySelector(
    ".wc-appointments-appointment-form-button"
  );
  const showAppointmentForm = document.querySelector(
    ".show-appointment-button"
  );
  showAppointmentForm.removeAttribute("disabled");
  if (!appointmentForm || !appointmentFormButton) return;
  if (qty <= 0) {
    appointmentForm.classList.add("hidden");
    appointmentFormButton.classList.add("hidden");
    showAppointmentForm.setAttribute("disabled", true);
    return;
  }
  if (appointmentForm.hasAttribute("data-opened")) {
    appointmentForm.classList.remove("hidden");
    appointmentFormButton.classList.remove("hidden");
  }
};

/**
 * Handles the necessary updating of the values.
 * Updates quantity each time and update the max values of all the inputs, so that we cannot go above the max.
 */
const handleInputUpdate = () => {
  const currentQtyValue = !isNaN(
    parseInt(jQuery(".our-quantity-holder input").val())
  )
    ? parseInt(jQuery(".our-quantity-holder input").val())
    : 0;
  const paoStudentValue = !isNaN(parseInt(jQuery(".pao-student").val()))
    ? parseInt(jQuery(".pao-student").val())
    : 0;
  const paoChildValue = !isNaN(parseInt(jQuery(".pao-child").val()))
    ? parseInt(jQuery(".pao-child").val())
    : 0;
  jQuery(".qty").val(currentQtyValue + paoStudentValue + paoChildValue);
  updatePaoFields();
  setMaxValueForAddons();
  handleShowingNotification();
  checkForHidingCalendar(currentQtyValue + paoStudentValue + paoChildValue);
  jQuery(".qty").trigger("change"); // It is important to fire a change event to correctly update the price .
};

/**
 * Creates and connects the new quantity field.
 * Usage of jQuery is only because vanilla js does not appear to work as expected here.
 *
 * @param {HTMLInputElement} quantity The quantity element.
 */
const createQuantity = (quantity) => {
  const newQuantityHolder = document.querySelector(".our-quantity-holder");
  if (!newQuantityHolder) return;
  let newQuantity = document.createElement("input");
  newQuantity.id = quantity.id;
  newQuantity.classList.add("input-text");
  newQuantity.setAttribute("type", "number");
  newQuantity.setAttribute("value", 0);
  newQuantity.setAttribute("max", newQuantityHolder.getAttribute("data-max"));
  newQuantity.setAttribute("min", newQuantityHolder.getAttribute("data-min"));
  newQuantity.setAttribute("step", 1);
  newQuantity.setAttribute("inputmode", "numeric");
  newQuantityHolder.append(newQuantity);
  jQuery(".qty").attr("hidden", true);
  setInterval(() => {
    jQuery(".qty").attr("hidden", true);
  }, 400);
  jQuery(".our-quantity-holder input").on("change", handleInputUpdate);
};

/**
 * Updates the values of the student and child addon fields based on their current input values.
 */
const updatePaoFields = () => {
  const addons = document.querySelectorAll(
    ".wc-pao-addon-container input.wc-pao-addon-field"
  );
  if (addons.length <= 0 && addons.length >= 2) return;
  const paoStudentValue = !isNaN(parseInt(jQuery(".pao-student").val()))
    ? parseInt(jQuery(".pao-student").val())
    : 0;
  const paoChildValue = !isNaN(parseInt(jQuery(".pao-child").val()))
    ? parseInt(jQuery(".pao-child").val())
    : 0;
  jQuery(addons[0]).val(paoStudentValue).trigger("change");
  jQuery(addons[1]).val(paoChildValue).trigger("change");
};

/**
 * Creates the custom inputs for the student and child addons.
 */
const createCustomInputs = () => {
  // Check if custom inputs already exist to prevent duplicates
  if (document.querySelector(".pao-student") || document.querySelector(".pao-child")) {
    return;
  }
  
  // Initialize the needed elements.
  let studWrapper = document.createElement("p");
  studWrapper.classList.add("form-row", "form-row-wide", "wc-pao-addon-wrap");
  let childWrapper = document.createElement("p");
  childWrapper.classList.add("form-row", "form-row-wide", "wc-pao-addon-wrap");
  let newStudent = document.createElement("input");
  newStudent.setAttribute("type", "number");
  newStudent.setAttribute("min", 0);
  newStudent.setAttribute("value", 0);
  newStudent.setAttribute("inputmode", "numeric");
  newStudent.setAttribute(
    "max",
    jQuery(".our-quantity-holder input").attr("max")
  );
  newStudent.classList.add("input-text", "pao-student");
  let newChildren = document.createElement("input");
  newChildren.setAttribute("type", "number");
  newChildren.setAttribute("min", 0);
  newChildren.setAttribute("value", 0);
  newChildren.setAttribute("inputmode", "numeric");
  newChildren.setAttribute(
    "max",
    jQuery(".our-quantity-holder input").attr("max")
  );
  newChildren.classList.add("input-text", "pao-child");

  // Go through the addons and add the correct inputs to the correct place.
  const addons = document.querySelectorAll(".wc-pao-addon-container");
  if (addons.length <= 0 && addons.length >= 2) return;
  const wrapStudent = addons[0].appendChild(studWrapper);
  const studEl = wrapStudent.appendChild(newStudent);
  const wrapChild = addons[1].appendChild(childWrapper);
  const childEl = wrapChild.appendChild(newChildren);
  // Hide the actual fields.
  jQuery(".wc-pao-addon-field").attr("hidden", true);
  // Add needed event listeners to get the required updates.
  jQuery(studEl).on("change", handleInputUpdate);
  jQuery(childEl).on("change", handleInputUpdate);
  updatePaoFields();
};

/**
 * Handles hiding the forms and showing a new form that works according to the leiska.
 */
const overrideDefaultForms = () => {
  if (!document.querySelector("#wc-appointments-appointment-form")) return;
  const quantity = document.querySelector(".input-text.qty.text");
  createQuantity(quantity);
  createCustomInputs();
  setMaxValueForAddons();
  handleShowingNotification();
  handleInputUpdate();
};

/**
 * Handles translating the addon fields label to the correct labels.
 */
const applyTranslations = () => {
  // Check that we have everything we need.
  if (
    !window.custom_translations ||
    !window.custom_translations.translations ||
    !window.custom_translations.current_language ||
    !window.custom_translations.translations[
      window.custom_translations.current_language
    ]
  )
    return;

  const addons = document.querySelectorAll(".wc-pao-addon-container");
  if (!addons[0] || !addons[0].querySelector(".wc-pao-addon-name")) return;
  addons[0].querySelector(".wc-pao-addon-name").textContent =
    window.custom_translations.translations[
      window.custom_translations.current_language
    ].student;
  if (!addons[1] || !addons[1].querySelector(".wc-pao-addon-name")) return;
  addons[1].querySelector(".wc-pao-addon-name").textContent =
    window.custom_translations.translations[
      window.custom_translations.current_language
    ].child;
};

/**
 * Handles the initial setup of the appointment form.
 */
document.addEventListener("DOMContentLoaded", function () {
  const appointmentForm = document.querySelector(
    "#wc-appointments-appointment-form"
  );
  const appointmentFormButton = document.querySelector(
    ".wc-appointments-appointment-form-button"
  );
  const showAppointmentForm = document.querySelector(
    ".show-appointment-button"
  );
  if (!appointmentForm || !appointmentFormButton || !showAppointmentForm)
    return;
  const url = new URL(window.location.href);
  appointmentForm.classList.add("hidden");
  appointmentFormButton.classList.add("hidden");

  if (url.searchParams.has("time") || url.searchParams.has("date")) {
    appointmentForm.classList.remove("hidden");
    appointmentFormButton.classList.remove("hidden");
  }

  showAppointmentForm.addEventListener("click", function (event) {
    event.preventDefault();
    event.stopPropagation();
    const appointmentForm = document.querySelector(
      "#wc-appointments-appointment-form"
    );
    const appointmentFormButton = document.querySelector(
      ".wc-appointments-appointment-form-button"
    );
    if (!appointmentForm || !appointmentFormButton) return;
    appointmentForm.setAttribute("data-opened", true);
    appointmentForm.classList.remove("hidden");
    appointmentFormButton.classList.remove("hidden");
  });

  overrideDefaultForms();
});

/**
 * Updates the total translations.
 */
const updateTotalTranslations = () => {
  // Check that we have everything we need.
  if (
    !window.custom_translations ||
    !window.custom_translations.translations ||
    !window.custom_translations.current_language ||
    !window.custom_translations.translations[
      window.custom_translations.current_language
    ]
  )
    return;
  const totals = document.querySelector(".product-addon-totals");
  if (!totals || totals.querySelectorAll(".wc-pao-col1 strong").length === 0)
    return;
  const textCol = totals.querySelectorAll(".wc-pao-col1 strong");
  if (!textCol[1]) return;
  jQuery(textCol[1]).text(function (idx, textContent) {
    return textContent
      .split("-")
      .map((text, idx) => {
        text = text.trim();
        if (idx === 0) {
          text =
            window.custom_translations.translations[
              window.custom_translations.current_language
            ].student_total;
        }
        return text;
      })
      .join(" - ");
  });
};

/**
 * Handles updating the max value of the student addon based on the variation.
 *
 * This seems to not be working as expected since pa_manniskor is not present.
 */
const handleVariationUpdate = () => {
  // This assumes that the first addon is the student.
  const field = document.querySelector(".wc-pao-addon-field");
  if (!field) return;
  const value = parseInt(document.querySelector("#pa_manniskor").value);
  if (isNaN(value)) field.max = 0;
  else field.max = value;
};

/**
 * Handles the translation of the total text.
 */
document.addEventListener("DOMContentLoaded", () => {
  applyTranslations();
  jQuery(".cart").on("updated_addons", function () {
    updateTotalTranslations();
  });
  if (document.querySelector("#pa_manniskor")) {
    handleVariationUpdate();
    document.querySelector("#pa_manniskor").addEventListener("change", () => {
      handleVariationUpdate();
    });
  }
});
